module.exports = __webpack_public_path__ + "static/media/PA-Icon-Wasserhahn-neg.6a9f32c5.svg";